var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "100%",
        height: "100%",
        viewBox: "0 0 20 18",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M8 8.81372C10.2091 8.81372 12 7.02286 12 4.81372C12 2.60458 10.2091 0.813721 8 0.813721C5.79086 0.813721 4 2.60458 4 4.81372C4 7.02286 5.79086 8.81372 8 8.81372Z",
        },
      }),
      _c("path", {
        attrs: {
          d: "M8.67 9.83372C8.45 9.82372 8.23 9.81372 8 9.81372C5.58 9.81372 3.32 10.4837 1.39 11.6337C0.51 12.1537 0 13.1337 0 14.1637V16.8137H9.26C8.47 15.6837 8 14.3037 8 12.8137C8 11.7437 8.25 10.7437 8.67 9.83372Z",
        },
      }),
      _c("path", {
        attrs: {
          d: "M18.7499 12.8137C18.7499 12.5937 18.7199 12.3937 18.6899 12.1837L19.8299 11.1737L18.8299 9.44372L17.3799 9.93372C17.0599 9.66372 16.6999 9.45372 16.2999 9.30372L15.9999 7.81372H13.9999L13.6999 9.30372C13.2999 9.45372 12.9399 9.66372 12.6199 9.93372L11.1699 9.44372L10.1699 11.1737L11.3099 12.1837C11.2799 12.3937 11.2499 12.5937 11.2499 12.8137C11.2499 13.0337 11.2799 13.2337 11.3099 13.4437L10.1699 14.4537L11.1699 16.1837L12.6199 15.6937C12.9399 15.9637 13.2999 16.1737 13.6999 16.3237L13.9999 17.8137H15.9999L16.2999 16.3237C16.6999 16.1737 17.0599 15.9637 17.3799 15.6937L18.8299 16.1837L19.8299 14.4537L18.6899 13.4437C18.7199 13.2337 18.7499 13.0337 18.7499 12.8137ZM14.9999 14.8137C13.8999 14.8137 12.9999 13.9137 12.9999 12.8137C12.9999 11.7137 13.8999 10.8137 14.9999 10.8137C16.0999 10.8137 16.9999 11.7137 16.9999 12.8137C16.9999 13.9137 16.0999 14.8137 14.9999 14.8137Z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }